module.exports = __webpack_public_path__ + "static/optima-618e0b446912db890d7c9b34579ea859.png";